import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainSidebar from "../Mainsidebar";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import "../../Style/NewVendor.css";
import { path_url } from "../../Config/config";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import ImageToTextModal from "../components/ImageToTextModal";
import GroupCategory from "../components/GroupCategory";
import SpeechToText from "../../AI/SpeechToText";
import CsvImport_vendor from "./CsvImport_vendor";
import { Modal } from "@mui/material";
import { useCurrentUser } from "../../context/UserContext";

function NewVendor() {
  const { currentUser } = useCurrentUser();
  const [showModal, setShowModal] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const vendorId = useParams();
  const [myInitialValues, setMyInitialValues] = useState({
    // "readstatus":"...",
    // "product":"...",
    // "owner":"..."

    firstname: "",
    lastname: "",
    companyname: "",
    mobile: null,
    altphone: null,
    email: "",
    department: "",
    designation: "",
    category: "",
    reportTo: "",
    gstnumber: "",
    website: "",
    address1: "",
    address2: "",
    address3: "",
    city: "",
    pincode: null,
    state: "",
    country: "",
    notes: "",
    bestwaycontact: "Mobile",
    leadsource: "Indiamart",
    status: "OPEN",
    groupCategory: "",
    usercid: currentUser?.id || localStorage.getItem("userId") || localStorage.getItem("adminId"),
    useradminid: currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
    owner: currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
  });

  const options = [
    { value: "Phone", label: "Phone" },
    { value: "Email", label: "Email" },
  ];

  const Enum = [
    { value: "OPEN", label: "Open" },
    { value: "ATTEMPTEDCONTACT", label: "Attempted Contact" },
    { value: "NOTENGAGED", label: "Not Engaged" },
    { value: "NEEDSFOLLOWUP", label: "Needs Follow Up" },
    { value: "WORKING", label: "Working" },
    { value: "NEWOPPORTUNITY", label: "New Opportunity" },
    { value: "QUALIFIED", label: "Qualified" },
    { value: "DISQUALIFIED", label: "Disqualified" },
    { value: "CONVERTTOCUSTOMER", label: "Convert To Customer" },
  ];

  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (vendorId.id) {
        setLoading(true);
        const token = localStorage.getItem("accessToken");
        try {
          const response = await axios.get(
            `${path_url}/vendor/${vendorId.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            },
          );
          setMyInitialValues(response.data.body);
        } catch (error) {
          console.error("Fetch error:", error);
          toast.error("Failed to load vendor data.");
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [vendorId.id]);

  if (loading && vendorId.id) {
    return <div className="loader">Loading...</div>;
  }

  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <div className="mt-2">
            <Formik
              initialValues={myInitialValues}
              onSubmit={async (values) => {
                try {
                  const nameRegex = /^[a-zA-Z\s]{2,}$/;
                  const phoneNumberRegex = /^\d{10,15}$/;
                  const emailRegex =
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                  const pincodeRegex = /^\d{6}$/;
                  const stateCountryRegex = /^[a-zA-Z\s]+$/;
                  const addressRegex = /^[a-zA-Z0-9\s,.-]+$/;

                  const errors = [];
                  const req = [];
                  if (!values.firstname) {
                    req.push("Name");
                  }
                  if (!values.mobile) {
                    req.push("Phone number");
                  }
                  if (!values.email) {
                    req.push("Email address");
                  }

                  // Validate mandatory fields
                  if (
                    (values.firstname && !nameRegex.test(values.firstname)) ||
                    (values.lastname && !nameRegex.test(values.lastname))
                  ) {
                    errors.push("Name");
                  }
                  if (values.mobile && !phoneNumberRegex.test(values.mobile)) {
                    errors.push("Phone number");
                  }
                  if (values.email && !emailRegex.test(values.email)) {
                    errors.push("Email address");
                  }

                  if (values.pincode && !pincodeRegex.test(values.pincode)) {
                    errors.push("Pincode");
                  }
                  if (values.state && !stateCountryRegex.test(values.state)) {
                    errors.push("State name");
                  }
                  if (
                    values.country &&
                    !stateCountryRegex.test(values.country)
                  ) {
                    errors.push("Country name");
                  }
                  if (values.address1 && !addressRegex.test(values.address1)) {
                    errors.push("Address format");
                  }
                  if (!values.status) {
                    values.status = "OPEN";
                  }

                  if (req.length > 0) {
                    const reqMessage = req.join(", ") + " is required";
                    toast.error(reqMessage);
                  } else if (errors.length > 0) {
                    const errorMessage = "Invalid " + errors.join(", ");
                    toast.error(errorMessage);
                  } else {
                    const token = localStorage.getItem("accessToken");
                    // const data = vendorId.id
                    //   ? { ...values, id: vendorId.id }
                    //   : values;
                    const submitPayload = {
                      ...values,
                      usercid: values.usercid || currentUser?.id || localStorage.getItem("userId") || localStorage.getItem("adminId"),
                      useradminid: values.useradminid || currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
                      owner: values.owner || currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
                    };
                    const response = await axios.post(
                      `${path_url}/vendor`,
                      submitPayload,
                      {
                        headers: {
                          Authorization: `Bearer ${token}`,
                          "Content-Type": "application/json",
                        },
                      },
                    );

                    if (
                      response &&
                      (response.data?.statusCodeValue === 200 ||
                        response.status === 200 ||
                        response.status === 201)
                    ) {
                      toast.success(
                        vendorId.id
                          ? "Vendor updated successfully"
                          : "Vendor created successfully",
                      );
                      setTimeout(() => {
                        navigate(-1);
                      }, 1000);
                    } else if (response) {
                      toast.error(
                        response.data?.body || "Failed to submit form",
                      );
                    }
                  }
                } catch (error) {
                  console.error("Submit error:", error);
                  toast.error(
                    error.response?.data?.message ||
                    error.response?.data?.body ||
                    "Failed to save vendor. Please try again."
                  );
                }
              }}
            >
              {(formik) => (
                <form action="" onSubmit={formik.handleSubmit}>
                  <fieldset style={{ marginBottom: "5rem" }}>
                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ 
                              boxShadow: "0 1px 1px lightgray",
                              padding: "10px 15px",
                              alignItems: "center"
                            }}
                            className="d-flex mt-2 col-12 elevation-2 mb-2 justify-content-between flex-wrap"
                          >
                            <p
                              style={{ color: "gray" }}
                              className="m-0 custom-font-size"
                            >
                              <strong>
                                {vendorId.id ? "Update Vendor" : "New Vendor"}
                              </strong>
                            </p>

                            <div className="d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
                              <div className="input-with-speech m-0 d-flex align-items-center" style={{ marginRight: "10px" }}>
                                <input
                                  id="voice-input-box"
                                  type="text"
                                  placeholder="Voice input displayed here..."
                                  disabled
                                  style={{ margin: 0, marginRight: "8px", height: "38px" }}
                                />
                                <SpeechToText inputId="voice-input-box" />
                              </div>

                              <input
                                type="file"
                                id="scan-receipt-file-input"
                                name="uploadfile"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                              />
                              <label
                                htmlFor="scan-receipt-file-input"
                                className="btn btn-outline-secondary m-0"
                                style={{
                                  padding: "0 12px",
                                  borderRadius: "5px",
                                  border: "1px solid #17A2B8",
                                  background: "#17A2B8",
                                  color: "#fff",
                                  cursor: "pointer",
                                  height: "38px",
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                Scan Receipt
                              </label>
                              <img
                                onClick={() => setShowModal(true)}
                                src="/assets/import.png"
                                alt="import"
                                style={{
                                  height: "25px",
                                  width: "25px",
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                              />
                              {showModal && (
                                <Modal
                                  open={showModal}
                                  onClose={() => setShowModal(false)}
                                  aria-labelledby="csv-import-modal"
                                  aria-describedby="csv-import-description"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      backgroundColor: "white",
                                      padding: "20px",
                                      borderRadius: "8px",
                                      width: "400px",
                                      textAlign: "center",
                                      boxShadow:
                                        "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                    }}
                                  >
                                    <CsvImport_vendor
                                      closeModal={() => setShowModal(false)}
                                    />
                                    <button
                                      onClick={() => setShowModal(false)}
                                      style={{
                                        marginTop: "10px",
                                        backgroundColor: "gray",
                                        color: "white",
                                        border: "none",
                                        padding: "10px",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Close
                                    </button>
                                  </div>
                                </Modal>
                              )}
                            </div>
                          </div>
                          {file && <ImageToTextModal file={file} />}
                        </div>
                        {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Company Name</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Company Name"
                                  name="companyname"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.companyname}
                                />
                                {formik.touched.companyname &&
                                  formik.errors.companyname && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.companyname}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Name</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 d-flex p-0 justify-content-end">
                                <div className="col-sm-6 pb-1  forms">
                                  <input
                                    type="text"
                                    placeholder="First Name"
                                    name="firstname"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.firstname}
                                  />
                                  {formik.touched.firstname &&
                                    formik.errors.firstname && (
                                      <span style={{ color: "red" }}>
                                        {formik.errors.firstname}
                                      </span>
                                    )}
                                </div>

                                <div className="col-sm-6 justify-content-end forms">
                                  <input
                                    type="text"
                                    placeholder="Last Name"
                                    name="lastname"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.lastname}
                                  />
                                </div>
                                <div className="p-0 m-0 d-flex justify-content-center">
                                  {formik.touched.lastname &&
                                    formik.errors.lastname && (
                                      <span style={{ color: "red" }}>
                                        {formik.errors.lastname}
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Status</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <select
                                  name="status"
                                  id="status"
                                  className="selectBox custom-select "
                                  value={formik.values.status}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  {Enum.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Source</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <select
                                  name="leadsource"
                                  id="leadsource"
                                  className="selectBox custom-select "
                                  value={formik.values.leadsource}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  <option value="Indiamart">Indiamart</option>
                                  <option value="Website">Website</option>
                                  <option value="Referral">Referral</option>
                                  <option value="Social Media">Social Media</option>
                                  <option value="Cold Call">Cold Call</option>
                                  <option value="Other">Other</option>
                                </select>
                              </div>
                            </div>
                            {/* Group Category Field */}
                            <GroupCategory formik={formik} />
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Best Way to Contact</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <select
                                  name="bestwaycontact"
                                  id="bestwaycontact"
                                  className="selectBox custom-select "
                                  value={formik.values.bestwaycontact}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  <option value="Mobile">Mobile</option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Mobile</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="number"
                                  placeholder="Mobile"
                                  name="mobile"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.mobile}
                                />
                                {formik.touched.mobile &&
                                  formik.errors.mobile && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.mobile}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Phone</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="number"
                                  placeholder="Phone"
                                  name="altphone"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.altphone}
                                />
                                {formik.touched.altphone &&
                                  formik.errors.altphone && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.altphone}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Email</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Email"
                                  name="email"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.email}
                                />
                                {formik.touched.email &&
                                  formik.errors.email && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.email}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 mt-3 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ boxShadow: "0 1px 1px lightgray" }}
                            className=" col-12 m-1 mt-2 mb-3  elevation-2"
                          >
                            <p
                              style={{ color: "gray" }}
                              className=" p-1 m-0 custom-font-size"
                            >
                              <strong>Other Informations</strong>
                            </p>
                          </div>
                        </div>
                        {/* <div className="border rounded border-gray col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap ">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Department</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8  forms">
                                <input
                                  type="text"
                                  placeholder="Department"
                                  name="department"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.department}
                                />
                                {formik.touched.department &&
                                  formik.errors.department && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.department}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Designation</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Designation"
                                  name="designation"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.designation}
                                />
                                {formik.touched.designation &&
                                  formik.errors.designation && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.designation}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Category</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Category"
                                  name="category"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.category}
                                />
                                {formik.touched.category &&
                                  formik.errors.category && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.category}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>ReportTo</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="ReportTo"
                                  name="reportTo"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.reportTo}
                                />
                                {formik.touched.reportTo &&
                                  formik.errors.reportTo && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.reportTo}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>GSTIN</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="GST Number"
                                  name="gstnumber"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.gstnumber}
                                />
                                {formik.touched.gstnumber &&
                                  formik.errors.gstnumber && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.gstnumber}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Website</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="https://abc.com/"
                                  name="website"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.website}
                                />
                                {formik.touched.website &&
                                  formik.errors.website && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.website}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 mt-3 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ boxShadow: "0 1px 1px lightgray" }}
                            className=" col-12 m-1 mt-2 mb-3 elevation-2"
                          >
                            <p className="text-white p-1 m-0 custom-font-size">
                              <strong>Address</strong>
                            </p>
                          </div>
                        </div>
                        {/* <div className="border rounded border-gray col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap ">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Address1</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Address1"
                                  name="address1"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.address1}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Address2</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Address2"
                                  name="address2"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.address2}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Address3</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Address3"
                                  name="address3"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.address3}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>City</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="City"
                                  name="city"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.city}
                                />
                                {formik.touched.city && formik.errors.city && (
                                  <span style={{ color: "red" }}>
                                    {formik.errors.city}
                                  </span>
                                )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Pincode</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="number"
                                  placeholder="Pincode"
                                  name="pincode"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.pincode}
                                />
                                {formik.touched.pincode &&
                                  formik.errors.pincode && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.pincode}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>State</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="State"
                                  name="state"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.state}
                                />
                                {formik.touched.state &&
                                  formik.errors.state && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.state}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Country</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Country"
                                  name="country"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.country}
                                />
                                {formik.touched.country &&
                                  formik.errors.country && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.country}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Notes</strong>
                                </label>
                              </div>

                              <div className="col-12 col-sm-8 forms">
                                <textarea
                                  type="text"
                                  id="notes"
                                  name="notes"
                                  rows={5}
                                  placeholder="Notes"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.notes}
                                />
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex m-2 mb-3">
                              <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                                <button className="btn btn-sm btn-light border rounded border-gray">
                                  Cancel
                                </button>
                              </div>
                              <div className="col-12 col-sm-6 d-flex justify-content-center p-2">
                                <button
                                  type="submit"
                                  className="btn btn-sm border rounded border-gray btn-info "
                                  style={{ backgroundColor: "" }}
                                >
                                  Save
                                </button>
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              )}
            </Formik>
          </div>
          <UserFooter />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </>
  );
}

export default NewVendor;
